import { app } from '../../../../../../app';

app.config(config);

/** @ngInject */
function config($stateProvider) {
    $stateProvider.state('company.directory-integration.manage.domains.add-domain', {
        url: '/add-domain',
        views: {
            '@company.directory-integration.manage': 'companyDirectoryIntegrationManageDomainsAddDomain'
        },
    });
}



// WEBPACK FOOTER //
// ./src/portal/states/company/directory-integration/manage/domains/add-domain/add-domain.state.js